import client from '../client';

export async function list() {
  return client.get('/mtms/api/v1/teams');
}
